import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenamairca: "",
    webamairca: []
  },
  mutations: {
    login(state, data) {
      state.webamairca = data.user;
      state.webamairca = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.webamairca = [];
      state.tokenamairca = "";
    },
    webamairca(state, data) {
      state.webamairca = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("webamairca", data);
    }
  }
});
